export default defineNuxtPlugin(() => {
	const userRequestHeaders = useRequestHeaders(['cookie'])
	const config = useRuntimeConfig()

	const api = $fetch.create({
		baseURL: import.meta.server ? `${config.public.baseUrl}/api` : '/api',
		onRequest({ options }: any) {
			if (import.meta.server) {
				const headers = options.headers || {}

				options.headers = {
					...headers,
					...userRequestHeaders,
				}
			}
		},
	})

	return {
		provide: {
			api,
		},
	}
})
